<template>
  <form @submit="onSubmit($event)" autocomplete="off">
    <h3 class="mb-5">{{ title }}</h3>

    <div class="dropdown" :class="{open: focused}">
      <div
        class="form-group"
        :class="{'has-error has-feedback': password && !valid, 'has-success has-feedback': password && valid}"
      >
        <input
          :type="textSecurity ? 'text' : 'password'"
          :class="{'text-security-disc': textSecurity}"
          class="form-control"
          v-model="password"
          @focus="focused = true"
          @blur="focused = false"
          placeholder="New password"
          autocomplete="new-password"
        />
        <span
          v-if="password"
          :class="{'glyphicon-ok': valid, 'glyphicon-remove': !valid}"
          class="glyphicon form-control-feedback"
        ></span>
        <span v-if="password && !valid" class="help-block">Password doesn't satisfy the requirements.</span>
      </div>
      <div class="dropdown-menu p-4 px-md-5 pt-md-4 pb-md-5">
        <password-requirements :password="password" @validity-change="onValidityChange($event)"></password-requirements>
      </div>
    </div>

    <div
      class="form-group"
      :class="{
        'has-error has-feedback': passwordConfirmation && !match,
        'has-success has-feedback': passwordConfirmation && match,
      }"
    >
      <input
        :type="textSecurity ? 'text' : 'password'"
        :class="{'text-security-disc': textSecurity}"
        class="form-control"
        v-model="passwordConfirmation"
        placeholder="Confirm new password"
        autocomplete="new-password"
      />
      <span
        v-if="passwordConfirmation"
        :class="{'glyphicon-ok': match, 'glyphicon-remove': !match}"
        class="glyphicon form-control-feedback"
      ></span>
      <span v-if="passwordConfirmation && !match" class="help-block">Passwords don't match.</span>
    </div>

    <button type="submit" class="btn btn-primary btn-lg mt-3" :disabled="disabled">
      <img v-if="loading" src="/wp-content/themes/snappy-theme/assets/images/loading2.gif" class="loading-image" />
      <span>{{ buttonText }}</span>
    </button>
  </form>
</template>

<script>
import PasswordRequirements from './PasswordRequirements';

export default {
  name: 'password-change-form',
  components: {PasswordRequirements},
  props: {
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      valid: false,
      focused: false,
      textSecurity: CSS.supports('(-webkit-text-security: disc)')
    };
  },
  computed: {
    disabled() {
      return !this.valid || !this.match || this.loading;
    },
    match() {
      return this.password === this.passwordConfirmation;
    },
  },
  methods: {
    resetData() {
      this.password = '';
      this.passwordConfirmation = '';
    },
    onSubmit(event) {
      event.preventDefault();

      if (!this.disabled) {
        this.$emit('save', {password: this.password, passwordConfirmation: this.passwordConfirmation});
      }
    },
    onValidityChange(valid) {
      this.valid = valid;
    },
  },
};
</script>

<style lang="scss" scoped>
form {
  max-width: 400px;
}

.text-security-disc {
  -webkit-text-security: disc;
}

.has-success .form-control-feedback {
  visibility: unset;
}

.loading-image {
  display: inline-block;
  margin-right: 5px;
  width: 20px;
}
</style>
